import { AbstractCustomerProvider, Customer } from './types';



export class CustomerProvider implements AbstractCustomerProvider {

  private baseUrl: string;

  constructor() {
    let serverUrl = process.env.REACT_APP_ENVIRONMENT === 'production' ?'https://api.tickertribe.com': "http://localhost:4000";
    this.baseUrl = serverUrl + '/stockapi';
    
  }

  async createCustomer(customer: Customer): Promise<Customer> {
      const url = this.baseUrl + '/createUser'
      const body = {
        "userName": customer.username,
        "email": customer.email,
        "password": customer.password,
        "isThirdPartyLogin": true,
        "thirdPartyId": customer.thirdPartyId,
        "thirdPartyType": "GOOGLE",
        "thirdPartyToken": customer.thirdPartyToken,
        profilePicLink: customer.profile_image
      }
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error('Failed to create customer');
    }

    const data = await response.json();
    return data as Customer;
  }
  
  async getCustomerByEmail(email: string): Promise<Customer> {
    const url = this.baseUrl + '/GetUser';
    const body = {
        "email": email
      }
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error('Failed to create customer');
    }

    const data = await response.json();
    
    return data as Customer;
  }

}